import React from "react";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@ui/alert-dialog";
import { SVG } from "@components/items/common/SVG";
import { useTranslation } from "react-i18next";
import TranslatedText from "@components/items/display/TranslatedText";

const ActivateSubscriptionAlert = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (state: boolean) => void;
}) => {
  const { t } = useTranslation();
  const onOpenChange = (open: boolean) => {
    if (open) setOpen(false);
  };

  return (
    <AlertDialog
      open={open}
      onOpenChange={(open) => {
        onOpenChange(open);
      }}
    >
      <AlertDialogContent className="flex w-1/5 flex-col items-center justify-center bg-white dark:border-none dark:bg-[#37383F]">
        <AlertDialogHeader className="flex flex-col items-center justify-center">
          <AlertDialogTitle>
            <SVG src="/assets/icons/gift.svg" />
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center dark:text-white">
            {t(
              `settings.dialogs.${"your monthly subscription has been successfully activated"}`
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-x-4">
          <AlertDialogCancel
            onClick={() => setOpen(false)}
            className="bg-primary px-24 font-normal text-white hover:bg-primary/80 hover:text-white dark:border-none"
          >
            <TranslatedText text={`settings.buttons.${"done"}`} />
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ActivateSubscriptionAlert;
